var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2Wheeler(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 33.254,
    viewBox: "0 0 50 33.254",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "2 wheeler",
    transform: "translate(-332.402 -228)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 5707",
    width: 12.041,
    height: 2.18,
    rx: 1.09,
    transform: "translate(334.677 230.948)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40872",
    d: "M359.961 250.829a.381.381 0 0 0 .07-.01.422.422 0 0 0 .343-.37v-1.38a.422.422 0 0 0-.141-.3.409.409 0 0 0-.159-.083.645.645 0 0 0-.19-.013h-1.3l-9.794.011a.394.394 0 0 0-.291.128.4.4 0 0 0-.1.3v1.231a.588.588 0 0 0 .014.16.4.4 0 0 0 .336.288h2.766l4.4.008 2.969.011.808.007-.808.007-2.969.011-4.4.008h-2.784a.479.479 0 0 1-.174-.056.466.466 0 0 1-.222-.281.57.57 0 0 1-.017-.18V249.1a.486.486 0 0 1 .122-.352.462.462 0 0 1 .345-.152l9.794.011h1.3a.811.811 0 0 1 .2.017.444.444 0 0 1 .174.093.453.453 0 0 1 .156.331v.917c0 .176 0 .329-.007.467a.445.445 0 0 1-.17.294.422.422 0 0 1-.194.08.251.251 0 0 1-.077.023z",
    transform: "translate(-13.671 -17.701)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 373",
    cx: 5.753,
    cy: 5.753,
    r: 5.753,
    transform: "rotate(-2.75 5387.886 -7589.963)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40873",
    d: "M604.076 420.84v.016a5.753 5.753 0 1 0 11.505.166v-.016z",
    transform: "translate(-233.448 -165.707)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40874",
    d: "M616.247 396.808a4.04 4.04 0 1 0 4.1-3.981 4.039 4.039 0 0 0-4.1 3.981z",
    transform: "translate(-243.907 -141.635)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40875",
    d: "M620.347 392.827a4.04 4.04 0 0 0-4.1 3.98l8.078.117a4.04 4.04 0 0 0-3.978-4.097z",
    transform: "translate(-243.909 -141.635)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40876",
    d: "M627.468 406.473a2.461 2.461 0 1 0 2.5-2.424 2.461 2.461 0 0 0-2.5 2.424z",
    transform: "translate(-253.549 -151.277)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40877",
    d: "M601.12 360.189s5.89-1.781 8.325 4.618l-12.326 3.819z",
    transform: "translate(-227.471 -113.393)",
    style: {
      fill: "#00c9a6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 374",
    cx: 5.753,
    cy: 5.753,
    r: 5.753,
    transform: "rotate(-2.75 5370.138 -6850.531)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40878",
    d: "M351.786 420.84v.016a5.753 5.753 0 1 0 11.505.166V421z",
    transform: "translate(-16.656 -165.707)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40879",
    d: "M364 396.808a4.04 4.04 0 1 0 4.1-3.981 4.04 4.04 0 0 0-4.1 3.981z",
    transform: "translate(-27.149 -141.635)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40880",
    d: "M368.092 392.828a4.04 4.04 0 0 0-4.092 3.98l8.078.117a4.04 4.04 0 0 0-3.986-4.1z",
    transform: "translate(-27.152 -141.636)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40881",
    d: "M375.178 406.473a2.461 2.461 0 1 0 2.5-2.424 2.461 2.461 0 0 0-2.5 2.424z",
    transform: "translate(-36.757 -151.277)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40882",
    d: "M390.816 402.293c-.032.017-3.028-.463-3.028-.463a1.829 1.829 0 0 1-1.366.715c-1.294.062-2.559.12-3.658.169a1.857 1.857 0 0 0-1.773 1.932 1.859 1.859 0 0 0 1.783 1.778l6.378.252a4.256 4.256 0 0 0 3.1-1.415z",
    transform: "translate(-41.75 -149.371)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40883",
    d: "M339.565 293.981s-.273-5.607 5-6.775v-.719h18.458v1.725s-2.709 3.263-1.829 5.971a11.849 11.849 0 0 0 1.161 2.986h10.5a7.176 7.176 0 0 0 1.327-3.981c.056-2.378-.931-6.443-1.67-9.042-.667-2.371-1.089-4.346-1.089-4.346l3.152-1.051s5.832 7.633 6.07 8.055a5.192 5.192 0 0 1 .858 3.622c-.19 2.192-5.437 8.954-6.813 9.717a10.259 10.259 0 0 1-3.86 1c-1.075.166-9.028.056-11.109.024a4.081 4.081 0 0 1-2.054-.57 4.614 4.614 0 0 1-1.605-2.026l-1.1-2.144z",
    transform: "translate(-6.153 -43.609)",
    style: {
      fill: "#00c9a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40884",
    d: "m334.825 384.26-2.325 3.64a.563.563 0 0 0 .691.833 2.708 2.708 0 0 0 .781-.529 36.171 36.171 0 0 0 2.955-3.677z",
    transform: "translate(0 -134.274)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40885",
    d: "M370.889 350.147a.163.163 0 0 1 .014-.053l.046-.153a4.047 4.047 0 0 0 .122-.6 4.241 4.241 0 0 0-.36-2.2 4.6 4.6 0 0 0-.857-1.287 5.622 5.622 0 0 0-1.407-1.078 7.123 7.123 0 0 0-1.843-.687 9.707 9.707 0 0 0-2.111-.218 15.908 15.908 0 0 0-2.111.156c-.681.091-1.334.2-1.95.345a11.551 11.551 0 0 0-3.131 1.158 7.748 7.748 0 0 0-1.788 1.366c-.186.191-.319.35-.408.459l-.1.125a.253.253 0 0 1-.037.041 4.728 4.728 0 0 1 .523-.644 7.6 7.6 0 0 1 1.784-1.392 11.447 11.447 0 0 1 3.142-1.179 21.559 21.559 0 0 1 1.954-.35 16.008 16.008 0 0 1 2.127-.158 9.682 9.682 0 0 1 2.122.221 7.208 7.208 0 0 1 1.86.7 5.656 5.656 0 0 1 1.425 1.095 4.632 4.632 0 0 1 .86 1.309 4.222 4.222 0 0 1 .341 2.223 3.59 3.59 0 0 1-.141.6l-.053.152a.288.288 0 0 1-.023.049z",
    transform: "translate(-19.393 -99.505)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40886",
    d: "M435.408 355.933c-.008 0 .03-.089.069-.249a1.819 1.819 0 0 0 .021-.7 2.891 2.891 0 0 0-.343-.977 3.34 3.34 0 0 0-.34-.512 3.087 3.087 0 0 0-.457-.474 3.994 3.994 0 0 0-1.1-.642 5.168 5.168 0 0 0-1.007-.281 6.591 6.591 0 0 0-.7-.08 2.07 2.07 0 0 1-.259-.02.226.226 0 0 1 .068 0h.193a5.257 5.257 0 0 1 .7.058 4.864 4.864 0 0 1 1.024.263 4.01 4.01 0 0 1 1.126.649 3.223 3.223 0 0 1 .467.485 3.517 3.517 0 0 1 .342.525 2.8 2.8 0 0 1 .335 1 1.734 1.734 0 0 1-.044.712 1.014 1.014 0 0 1-.068.181.247.247 0 0 1-.027.062z",
    transform: "translate(-84.974 -106.546)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5967",
    style: {
      opacity: 0.4
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40887",
    d: "M346.82 244.471a7.392 7.392 0 0 1 2.779 1.126 4.912 4.912 0 0 1 1.862 2.313 4.057 4.057 0 0 1-.075 2.99l1.3.108a4.789 4.789 0 0 0-1.093-4.408 6.473 6.473 0 0 0-4.777-2.134"
  }))), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 5708",
    width: 13.824,
    height: 13.865,
    rx: 2,
    transform: "translate(333.786 229.018)",
    style: {
      fill: "#0254a3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40888",
    d: "M355.7 279.077c0 .021-3.108.037-6.941.037s-6.942-.015-6.942-.037 3.107-.037 6.942-.037 6.941.017 6.941.037z",
    transform: "translate(-8.093 -43.858)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40889",
    d: "M393.041 338.187c0 .02-4.149.037-9.265.037s-9.265-.017-9.265-.037 4.148-.037 9.265-.037 9.265.017 9.265.037z",
    transform: "translate(-36.183 -94.651)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40890",
    d: "M453.8 322.35a1.6 1.6 0 0 0 .335-.827c.028-.463-.183-1.043-.682-1.043h-6.373a1.87 1.87 0 0 0-1.87 1.87z",
    transform: "translate(-96.935 -79.468)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40891",
    d: "m558.422 248.016-1.109-2.312a1.407 1.407 0 0 1 .563-1.808l3.315-1.977a1.111 1.111 0 0 1 .573-.159h.716l.281 4.673-1.1.426.7 1.137z",
    transform: "translate(-193.152 -11.824)",
    style: {
      fill: "#00c9a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40892",
    d: "M594.91 243s1.134.26 1.276 2.008a2.21 2.21 0 0 1-1 2.293z",
    transform: "translate(-225.572 -12.889)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40893",
    d: "M551.408 262.257s-2.292 1.086-2.572 1.266a.534.534 0 0 0-.208.722c.259.649 1.331.038 1.331.038l2.134-1.067s.82-.387.516-.872c-.338-.544-1.201-.087-1.201-.087z",
    transform: "translate(-185.751 -29.283)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40895",
    d: "M558.6 229.579c0 .872-.4 1.579-.895 1.579s-.895-.7-.895-1.579.4-1.579.895-1.579.895.7.895 1.579z",
    transform: "translate(-192.833)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40896",
    d: "m564.21 245.01.492 1.705a.442.442 0 0 0 .229-.5c-.124-.584-.194-1-.329-1.511-.017-.051-.393.31-.393.31",
    transform: "translate(-199.192 -14.346)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5968",
    style: {
      opacity: 0.4
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40897",
    d: "M355.281 251.296c-.048-.141-.1-.281-.141-.432s-.1-.281-.132-.422a4.531 4.531 0 0 1-.124-.643c-.83 3.377.438 5.759 2.613 5.926 3.18.245 7.056.422 8.624.011a6.667 6.667 0 0 0 4.156-3.526c.25-.393 2.523-4.548 1.126-8.548a58.66 58.66 0 0 0-3.82-8.248l-2.312.777s.422 1.97 1.093 4.339c.739 2.6 1.726 6.664 1.67 9.042a7.176 7.176 0 0 1-1.327 3.98h-10.5a9.083 9.083 0 0 1-.919-2.251"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40898",
    d: "m336.569 375.882.075-.8 19.175 2.209a1.894 1.894 0 0 1 1.643 2.212l-.086.485-19.839-2.888a1.126 1.126 0 0 1-.968-1.218z",
    transform: "translate(-3.576 -126.385)",
    style: {
      fill: "#ff725e"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5969",
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40899",
    d: "m336.569 375.882.075-.8 19.175 2.209a1.894 1.894 0 0 1 1.643 2.212l-.086.485-19.839-2.888a1.126 1.126 0 0 1-.968-1.218z",
    transform: "translate(-3.576 -126.385)",
    style: {
      fill: "#007863"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5970",
    style: {
      opacity: 0.36
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40900",
    d: "M370.276 254.86s4.221-4.643 5.092-8.293a8.206 8.206 0 0 1 1.307.1s-2.496 6.783-6.399 8.193z"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40901",
    d: "M605.278 348.34a.679.679 0 0 1 .023.117c.011.077.034.191.048.339a5.166 5.166 0 0 1-.032 1.266 6.4 6.4 0 0 1-.563 1.784 20.214 20.214 0 0 1-1.117 2 26.683 26.683 0 0 1-2.471 3.34c-.343.407-.628.73-.825.953l-.228.255a.971.971 0 0 1-.083.086.626.626 0 0 1 .072-.094l.218-.264.806-.967a29.008 29.008 0 0 0 2.448-3.346 21.42 21.42 0 0 0 1.126-1.988 6.527 6.527 0 0 0 .563-1.764 5.632 5.632 0 0 0 .055-1.249c-.01-.148-.028-.262-.034-.341a.618.618 0 0 1-.006-.127z",
    transform: "translate(-229.972 -103.408)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40902",
    d: "M577.522 410.883a5.637 5.637 0 0 1-.677-.611 5.786 5.786 0 0 1-.625-.663 11.286 11.286 0 0 1 1.302 1.274z",
    transform: "translate(-209.512 -156.057)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40903",
    d: "M496.43 410.862a1.953 1.953 0 0 1 .311-.6 1.98 1.98 0 0 1 .443-.511c.015.016-.177.246-.383.552s-.351.567-.371.559z",
    transform: "translate(-140.949 -156.177)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40904",
    d: "M426.519 410.561a2.832 2.832 0 0 0 .576-.732 2.518 2.518 0 0 0 .281-.964 2.239 2.239 0 0 0-1.01-2.111 2.514 2.514 0 0 0-.926-.387 2.83 2.83 0 0 0-.93-.013.27.27 0 0 1 .062-.018 1.541 1.541 0 0 1 .186-.037 2.208 2.208 0 0 1 .692.017 2.517 2.517 0 0 1 .954.381 2.274 2.274 0 0 1 1.04 2.18 2.519 2.519 0 0 1-.3.985 2.182 2.182 0 0 1-.422.549 1.443 1.443 0 0 1-.141.122.261.261 0 0 1-.062.028z",
    transform: "translate(-79.148 -153.196)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40905",
    d: "M388.468 417.966a3.023 3.023 0 0 1-.069-.675 3.2 3.2 0 0 1 0-.681 6.315 6.315 0 0 1 .065 1.356z",
    transform: "translate(-48.102 -162.072)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40906",
    d: "M391.583 417.959a6.518 6.518 0 0 1-.173-1.359 3.312 3.312 0 0 1 .122.675 3.278 3.278 0 0 1 .051.684z",
    transform: "translate(-50.705 -162.063)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40907",
    d: "M385.262 333.547c0 .02-2.331.037-5.206.037s-5.206-.017-5.206-.037 2.331-.037 5.206-.037 5.206.016 5.206.037z",
    transform: "translate(-36.475 -90.664)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40908",
    d: "M394.967 260.92c-.021 0-.037-2.673-.037-5.963s.01-5.957.037-5.957.037 2.673.037 5.964-.018 5.956-.037 5.956z",
    transform: "translate(-53.73 -18.045)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40909",
    d: "M384.985 260.868c-.02 0 .08-2.673.224-5.96s.281-5.959.3-5.957-.079 2.673-.222 5.96-.275 5.958-.302 5.957z",
    transform: "translate(-45.182 -18.002)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40910",
    d: "M352.835 401.306a.46.46 0 0 1-.062-.063c-.037-.042-.1-.1-.163-.189a5.4 5.4 0 0 1-.519-.763 5.829 5.829 0 0 1 .024-5.836 5.3 5.3 0 0 1 .525-.758c.068-.086.128-.141.166-.189s.06-.063.062-.06a.353.353 0 0 1-.051.07c-.034.046-.091.108-.155.2a6.022 6.022 0 0 0-.03 7.321c.062.089.118.152.152.2a.418.418 0 0 1 .051.067z",
    transform: "translate(-16.256 -142.169)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2506",
    d: "M417.179 163a1.179 1.179 0 0 1 1.179 1.179 1.179 1.179 0 0 1-1.179 1.179 1.179 1.179 0 0 1-1.179-1.179 1.179 1.179 0 0 1 1.179-1.179z",
    transform: "translate(-79.479 74.39)",
    style: {
      fill: "#00de9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2507",
    d: "M417.179 108a1.179 1.179 0 0 1 1.179 1.179 1.179 1.179 0 0 1-1.179 1.179 1.179 1.179 0 0 1-1.179-1.179 1.179 1.179 0 0 1 1.179-1.179z",
    transform: "translate(-79.479 126.302)",
    style: {
      fill: "#00de9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2508",
    d: "M417.179 53a1.179 1.179 0 0 1 1.179 1.179 1.179 1.179 0 0 1-1.179 1.179A1.179 1.179 0 0 1 416 54.179 1.179 1.179 0 0 1 417.179 53z",
    transform: "translate(-79.479 178.215)",
    style: {
      fill: "#00de9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2509",
    d: "M472.179 163a1.179 1.179 0 0 1 1.179 1.179 1.179 1.179 0 0 1-1.179 1.179 1.179 1.179 0 0 1-1.179-1.179 1.179 1.179 0 0 1 1.179-1.179z",
    transform: "translate(-131.392 74.39)",
    style: {
      fill: "#00de9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2510",
    d: "M472.179 108a1.179 1.179 0 0 1 1.179 1.179 1.179 1.179 0 0 1-1.179 1.179 1.179 1.179 0 0 1-1.179-1.179 1.179 1.179 0 0 1 1.179-1.179z",
    transform: "translate(-131.392 126.302)",
    style: {
      fill: "#00de9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2511",
    d: "M472.179 53a1.179 1.179 0 0 1 1.179 1.179 1.179 1.179 0 0 1-1.179 1.179A1.179 1.179 0 0 1 471 54.179 1.179 1.179 0 0 1 472.179 53z",
    transform: "translate(-131.392 178.215)",
    style: {
      fill: "#00de9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2512",
    d: "M527.179 108a1.179 1.179 0 0 1 1.179 1.179 1.179 1.179 0 0 1-1.179 1.179 1.179 1.179 0 0 1-1.179-1.179 1.179 1.179 0 0 1 1.179-1.179z",
    transform: "translate(-183.304 126.302)",
    style: {
      fill: "#00de9d"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2Wheeler);
export default __webpack_public_path__ + "static/media/2_wheeler.f65920cbdccbf76f90d758104b98f65c.svg";
export { ForwardRef as ReactComponent };